import { initializeTranslations as initializeTranslationsForOwaDatetime } from 'owa-datetime/lib/localization/getLocalizedString';
import { initializeTranslations as initializeTranslationsForOwaTimeFormat } from 'owa-timeformat/lib/localization/getLocalizedString';
import { logUsage } from 'owa-analytics';
import type { Culture } from 'owa-shared-localization';

const FALLBACK_CULTURE = 'en';
const MODULE_NOT_FOUND_ERROR = 'MODULE_NOT_FOUND';
const RETRYABLE_ERROR_CODES = ['ChunkLoadError'];

const tryInitializeTranslationsForOwaDateTime = (culture: Culture) =>
    Promise.all([
        initializeTranslationsForOwaDatetime(culture),
        initializeTranslationsForOwaTimeFormat(culture),
    ]);

/**
 * Initializes translations for OWA dateTime and timeFormat
 * If the culture is not supported, we log it and fallback to "en"
 * @param culture
 */
export const initializeTranslationsForOwaDateTimeWithRetry = async (
    culture: Culture,
    retryCount: number = 5
) => {
    try {
        await tryInitializeTranslationsForOwaDateTime(culture);
    } catch (error) {
        // If the culture is not supported, fallback to "en"
        if (error.code === MODULE_NOT_FOUND_ERROR) {
            logUsage('InitLocError', { culture, e: error.message }, { isCore: true });

            await initializeTranslationsForOwaDateTimeWithRetry(FALLBACK_CULTURE);
        } else if (isErrorRetryable(error.name) && retryCount > 0) {
            // If the error is retry-able, retry initialization
            await initializeTranslationsForOwaDateTimeWithRetry(culture, retryCount - 1);
        } else {
            throw error;
        }
    }
};

const isErrorRetryable = (errorCode: string) => RETRYABLE_ERROR_CODES.includes(errorCode);
